import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { hrmPanels } from "../hrmModulesData";
import HrmImagePlaceholder from "./HrmImagePlaceholder";

const FeatureGrid: React.FC<{ left: string[]; right: string[] }> = ({ left, right }) => (
  <div className="hrm-panel__features">
    <ul className="hrm-panel__list">
      {left.map((item) => (
        <li key={item}>
          <span className="hrm-panel__dot" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
    <ul className="hrm-panel__list">
      {right.map((item) => (
        <li key={item}>
          <span className="hrm-panel__dot" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const HrmPanelsSection: React.FC = () => {
  return (
    <section className="hrm-panels" aria-labelledby="hrm-panels-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="hrm-panels-title" className="wdev-section-head__title">
            Admin &amp; Employee Portals
          </h2>
          <p className="hrm-panels__lead">
            Fully integrated panels for HR administrators and employee self-service access.
          </p>
        </AnimatedSection>

        <div className="hrm-panels__stack">
          {hrmPanels.map((panel, index) => (
            <motion.article
              key={panel.id}
              className={`hrm-panel ${panel.imagePosition === "right" ? "hrm-panel--reverse" : ""}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: index * 0.1 }}
            >
              <div className="hrm-panel__visual">
                <HrmImagePlaceholder
                  variant={panel.id === "admin" ? "wide" : "phone"}
                  label={panel.placeholderLabel}
                  hint={panel.placeholderHint}
                  className="hrm-panel__placeholder"
                />
              </div>

              <div className="hrm-panel__content">
                <h3 className="hrm-panel__title">{panel.title}</h3>
                <p className="hrm-panel__desc">{panel.description}</p>
                <FeatureGrid left={panel.featuresLeft} right={panel.featuresRight} />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HrmPanelsSection;
